/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class AdvertisingPlatformServiceAddCommissionGroupRequest {
    'recordNumber': string;
    'shouldUpdateAllBillableChildOrgs': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "recordNumber",
            "baseName": "record_number",
            "type": "string",
            "format": ""
        },
        {
            "name": "shouldUpdateAllBillableChildOrgs",
            "baseName": "should_update_all_billable_child_orgs",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServiceAddCommissionGroupRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

